const baseUrl = process.env.REACT_APP_API_URL + '/api';

const HTTP_NO_AUTORIZADO = 401;
const RUTA_LOGIN = '/auth/login';

// El backend marca con `sesionInvalida` los 401 de un token que ya no sirve (caducado, contraseña
// cambiada o usuario eliminado). Los 401 por falta de permisos no lo llevan y no cierran la sesión.
// La recarga completa limpia el estado de Redux de la sesión anterior.
const cerrarSesionSiNoEsValida = async (respuesta) => {
    if (respuesta?.status !== HTTP_NO_AUTORIZADO) return respuesta;

    let cuerpo;
    try {
        cuerpo = await respuesta.clone().json();
    } catch (errorAlLeerElCuerpo) {
        return respuesta;
    }
    if (!cuerpo?.sesionInvalida) return respuesta;

    localStorage.removeItem('barbgest-token');
    localStorage.removeItem('barbgest-token-init-date');
    const yaEstaEnElLogin = window.location.pathname === RUTA_LOGIN;
    if (!yaEstaEnElLogin) window.location.assign(RUTA_LOGIN);

    return respuesta;
};

const fetchSinToken = (endpoint, data, method = 'GET') => {

    const url = `${baseUrl}/${endpoint}`;

    if (method === 'GET') {
        return fetch(url);
    } else {
        return fetch(url, {
            method,
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
    }

}

const fetchConToken = (endpoint, data, method = 'GET', timeoutMs = 30000) => {

    const url = `${baseUrl}/${endpoint}`;

    const token = localStorage.getItem('barbgest-token') || '';

    // Crear AbortController para manejar timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

    const fetchPromise = method === 'GET' 
        ? fetch(url, {
            method,
            headers: {
                'x-token': token
            },
            signal: controller.signal
        })
        : fetch(url, {
            method,
            headers: {
                'Content-type': 'application/json',
                'x-token': token
            },
            body: JSON.stringify(data),
            signal: controller.signal
        });

    // Limpiar el timeout cuando la petición termine
    return fetchPromise
        .then(cerrarSesionSiNoEsValida)
        .finally(() => clearTimeout(timeoutId));
}

const archivoConToken = (endpoint, data, method = 'GET') => {

    const url = `${baseUrl}/${endpoint}`;

    const token = localStorage.getItem('barbgest-token') || '';

    if (method === 'GET') {
        return fetch(url, {
            method,
            headers: {
                'x-token': token
            }
        }).then(cerrarSesionSiNoEsValida);
    } else {
        return fetch(url, {
            method,
            headers: {
                'x-token': token
            },
            body: data
        }).then(cerrarSesionSiNoEsValida);
    }
}

const uploadFile = (folder, file, name) => {
    const token = localStorage.getItem('barbgest-token') || '';

    const url = `${baseUrl}/resources/upload`;
    const formData = new FormData();
    formData.append('archivo', file);
    formData.append("folder", folder)
    formData.append("name", name)

    return fetch(url, {
        method: "POST",
        headers: {
            'x-token': token
        },
        body: formData
    }).then(cerrarSesionSiNoEsValida);
}


export {
    fetchSinToken,
    fetchConToken,
    archivoConToken,
    uploadFile
}